/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transparent_Png_RecommendedInputs */

const en_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent PNG recommended. Max 5MB.`)
};

const es_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se recomienda PNG transparente. Máx 5MB.`)
};

const fr_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG transparent recommandé. Max 5Mo.`)
};

const de_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparentes PNG empfohlen. Max 5MB.`)
};

const ja_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透過PNGを推奨。最大5MB。`)
};

const zh_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建议使用透明PNG格式。最大5MB。`)
};

const ar_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يُوصى بصيغة PNG شفافة. الحد الأقصى 5 ميغابايت.`)
};

const id_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkomendasikan PNG transparan. Maks 5MB.`)
};

const it_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigliato PNG trasparente. Max 5MB.`)
};

const ru_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуется прозрачный PNG. Макс. 5 МБ.`)
};

const pt_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG transparente recomendado. Máx 5MB.`)
};

const ko_transparent_png_recommended = /** @type {(inputs: Transparent_Png_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`투명 PNG 권장. 최대 5MB.`)
};

/**
* | output |
* | --- |
* | "Transparent PNG recommended. Max 5MB." |
*
* @param {Transparent_Png_RecommendedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const transparent_png_recommended = /** @type {((inputs?: Transparent_Png_RecommendedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transparent_Png_RecommendedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_transparent_png_recommended(inputs)
	if (locale === "es") return es_transparent_png_recommended(inputs)
	if (locale === "fr") return fr_transparent_png_recommended(inputs)
	if (locale === "de") return de_transparent_png_recommended(inputs)
	if (locale === "ja") return ja_transparent_png_recommended(inputs)
	if (locale === "zh") return zh_transparent_png_recommended(inputs)
	if (locale === "ar") return ar_transparent_png_recommended(inputs)
	if (locale === "id") return id_transparent_png_recommended(inputs)
	if (locale === "it") return it_transparent_png_recommended(inputs)
	if (locale === "ru") return ru_transparent_png_recommended(inputs)
	if (locale === "pt") return pt_transparent_png_recommended(inputs)
	return ko_transparent_png_recommended(inputs)
});